import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

interface Props {
  teamCount: number;
}
const TeamCount = styled.div`
  color: var(--gray-50);
  padding: 0 var(--spacing-05);
  height: 100%;
  display: flex;
  align-items: center;
`;

export const TeamCountCell: FC<Props> = ({ teamCount }) => {
  return (
    <TeamCount>
      <Tooltip
        title={
          <FormattedMessage
            id="resource_management.cells.role.team_count.tooltip"
            values={{ count: teamCount }}
          />
        }
      >
        ({teamCount})
      </Tooltip>
    </TeamCount>
  );
};
